import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDaily, useDevices } from '@daily-co/daily-react';
import {
  pageAtom,
  isAuthAtom,
  cameraInputAtom,
  micInputAtom,
  twitterAtom,
  myNftAtom,
  displayNameAtom,
  topMessageAtom,
} from '../../State';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeWhiteButton.svg';
import { ReactComponent as ProfileSVG } from '../Images/buttons/settingProfileButton.svg';
import { ReactComponent as CameraSVG } from '../Images/buttons/settingCameraButton.svg';
import { ReactComponent as LanguageSVG } from '../Images/buttons/settingLanguageButton.svg';
import { ReactComponent as AudioSVG } from '../Images/buttons/settingAudioButton.svg';
import { ReactComponent as FAQSVG } from '../Images/buttons/settingFAQbutton.svg';
import { ReactComponent as ContactSVG } from '../Images/buttons/settingContactButton.svg';
import { ReactComponent as AccountSVG } from '../Images/buttons/settingAccount.svg';
import { ReactComponent as LogoutSVG } from '../Images/buttons/settingLogout.svg';
import { getAuth, signOut } from 'firebase/auth';
import DataModel from '../Util/DataModel';
import isElectron from '../../Global';
import FaceImage from './FaceImage';
import './Setting.css';
import AddAccess from '../Util/AddAccess';
import FAQ from './FAQ';
import Feedback from './Feedback';
import { useTranslation } from 'react-i18next';
import isWindows from '../Util/isWindows';

export default function Setting() {
  //Daily系
  const callObject = useDaily();
  const localParticipant = useLocalParticipant();
  const { speakers, setMicrophone, setSpeaker } = useDevices();
  const { t, i18n } = useTranslation();

  //Recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [cameraInputState, setCameraInputState] = useRecoilState(cameraInputAtom);
  const [micInputState, setMicInputState] = useRecoilState(micInputAtom);
  const [displayNameState, setDisplayNameState] = useRecoilState(displayNameAtom);
  const [twitterValue, setTwitterValue] = useRecoilState(twitterAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);

  //その他
  const [settingState, setSettingState] = useState('profile');
  const navigate = useNavigate(); //リダイレクト用
  const cameraListRef = useRef([]);
  const micListRef = useRef([]);
  const speakerListRef = useRef([]);
  const userNameRef = useRef(null);
  const aboutMeRef = useRef(null);
  const [faceState, setFaceState] = useState(null);
  const [aboutMeState, setAboutMeState] = useState(null);
  const [userNameState, setUserNameState] = useState(false);
  const [aboutMeBlurState, setAboutMeBlurState] = useState(false);
  const twitterRef = useRef(null);
  const [twitterState, setTwitterState] = useState(false);
  const [logoutState, setLogoutState] = useState(false);

  useEffect(() => {
    //初期化
    init();

    //ユーザー情報
    getUserInfo();

    //デバイスリスト取得
    getDeviceList();
  }, []);

  //ユーザー情報取得
  async function getUserInfo() {
    if (authState) {
      let result = await DataModel.getSpecificUserData('aboutme', null, true);

      if (result != null && result.aboutme != null) {
        setAboutMeState(result.aboutme);
      }
    }
  }

  //初期化処理
  function init() {
    //アクセス
    AddAccess('page-view', 'setting');

    if (localStorage.getItem('displayName') != null) {
      setDisplayNameState(localStorage.getItem('displayName'));
    }

    if (localStorage.getItem('nftID') != null) {
      setMyNftState(localStorage.getItem('nftID'));
    } else {
      //localStorage.setItem('imageURL', 'doodle');
      setMyNftState('facelessboy');
    }

    // //ユーザー情報設定
    // if (localStorage.getItem('imageURL') != null) {
    //   setFaceState('./images/nft/thumb/' + localStorage.getItem('imageURL') + '.png');
    // } else {
    //   setFaceState('./images/nft/thumb/doodle.png');
    // }
  }

  //デバイスの一覧を取得
  const getDeviceList = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter((device) => device.kind === 'videoinput');
    const micDevices = devices.filter((device) => device.kind === 'audioinput');
    const speakerDevices = devices.filter((device) => device.kind === 'audiooutput');
    cameraListRef.current = videoDevices;
    micListRef.current = micDevices;
    speakerListRef.current = speakerDevices;
  };

  //カメラの選択済み
  var cameraSelected = 'default';
  if (cameraInputState != 'default') {
    cameraSelected = cameraInputState;
  } else if (localStorage.getItem('cameraInput') != null) {
    cameraSelected = localStorage.getItem('cameraInput');
  }

  //マイクの選択済み
  var micSelected = 'default';
  if (micInputState != 'default') {
    micSelected = micInputState;
  } else if (localStorage.getItem('micInput') != null) {
    micSelected = localStorage.getItem('micInput');
  }

  //カメラの更新
  const updateCamera = (e) => {
    //setCamera(e.target.value);
    setCameraInputState(e.target.value);
    localStorage.setItem('cameraInput', e.target.value);
  };

  //マイクの更新
  const updateMicrophone = (e) => {
    setMicrophone(e.target.value);
    setMicInputState(e.target.value);
    localStorage.setItem('micInput', e.target.value);
  };

  //スピーカーの更新
  const updateSpeakers = (e) => {
    localStorage.setItem('speakerOutput', e.target.value);
    setSpeaker(e.target.value);
  };

  //言語のアップデート
  const updateLanguage = (e) => {
    console.log(i18n.language);
    i18n.changeLanguage(e.target.value);
    //localStorage.setItem('speakerOutput', e.target.value);
    //setSpeaker(e.target.value);
  };

  //背景をタップ時
  const tapBack = () => {
    if (isElectron && pageState != 'setting') {
      window.myapi.closeWindow();
      setPageState('main');
    } else {
      setPageState('main');
    }
  };

  //プロフィールタップ
  const tapProfile = async () => {
    setSettingState('profile');
  };

  //カメラタップ
  const tapCamera = () => {
    setSettingState('camera');
  };

  //言語
  const tapLanguage = () => {
    setSettingState('language');
  };

  //オーディオアイコンタップ
  const tapAudio = () => {
    setSettingState('audio');
  };

  //アカウント
  const tapAccount = () => {
    setSettingState('account');
  };

  //FAQタップ
  const tapFAQ = () => {
    setSettingState('faq');
  };

  //コンタクトタップ
  const tapContact = () => {
    setSettingState('contact');
  };

  //ログアウトタップ
  const tapLogout = () => {
    //アクセス
    AddAccess('page-view', 'logout');

    var result = window.confirm(t('setting.Are you sure you want to logout?'));
    if (result) {
      setSettingState('logout');
      signOut(getAuth()).then(() => {
        setAuthState(false);
        localStorage.removeItem('token');
        localStorage.removeItem('imageURL');
        localStorage.removeItem('displayName');
        localStorage.removeItem('backImageURL');
        localStorage.removeItem('nftID');
        localStorage.removeItem('isAuth');
        localStorage.removeItem('meetingID');

        if (isElectron) {
          window.myapi.closeWindow();
        }
      });

      setPageState('main');
    }
  };

  //顔変更
  const onClickEditFace = async () => {
    if (isElectron && pageState != 'setting') {
      const url = await window.myapi.getURL('face');
      window.open(url, '_blank');
    } else {
      setPageState('nftList');
    }
  };

  //ユーザー名を設定
  const onChangeName = (e) => {
    setUserNameState(true);
    if (callObject != null) {
      callObject.setUserName(e.target.value);
    }

    //Recoil更新
    setDisplayNameState(e.target.value);

    //ローカル更新
    localStorage.setItem('displayName', e.target.value);
  };

  //ユーザー名を設定
  const editNameStart = async (e) => {
    //編集開始
    if (userNameState == false) {
      setUserNameState(true);
      setTimeout(() => {
        userNameRef.current?.focus();
      }, 10);
    }
    //編集終了
    else {
      saveUserName();
    }
  };

  //フォーカスがハズレた場合
  const userNameBlur = () => {
    //名前編集中の時
    if (userNameState) {
      setTimeout(() => {
        saveUserName();
      }, 10);
    }
  };

  //Aboutmeの変更時
  const onChangeAboutMe = (e) => {
    setAboutMeBlurState(true);
    setAboutMeState(e.target.value);
  };

  //フォーカスがハズレた場合
  const aboutMeBlur = () => {
    //名前編集中の時
    if (aboutMeBlurState) {
      setTimeout(async () => {
        //データベースに保存
        if (authState) {
          let result = await DataModel.saveUserData('aboutMe', aboutMeState);
          if (result != null) {
            setTopMessageState({
              type: 'joined',
              message: t('mypage.Saved!'),
            });
          }
        } else {
        }

        setAboutMeBlurState(false);
      }, 10);
    }
  };

  //ユーザー名の保存
  async function saveUserName() {
    setUserNameState(false);
    localStorage.setItem('displayName', userNameRef.current.value);
    setDisplayNameState(userNameRef.current.value);

    //エレクトロンの場合
    if (isElectron) {
      await window.myapi.nameChange(userNameRef.current.value);
    }

    if (callObject != null) {
      callObject.setUserName(userNameRef.current.value);
    }

    //データベースに保存
    if (authState) {
      let result = await DataModel.saveUserData('displayName', userNameRef.current.value);
      if (result != null) {
        setTopMessageState({
          type: 'joined',
          message: t('mypage.Saved!'),
        });
      }
    }
  }

  //ユーザー名を設定
  const editTwitterStart = async (e) => {
    //編集開始
    if (twitterState == false) {
      twitterRef.current?.focus();
      setTwitterState(true);
    }
    //編集終了
    else {
      setTwitterState(false);
      setTwitterValue(twitterRef.current.value);
      localStorage.setItem('twitterURL', twitterRef.current.value);

      //データベースに保存
      if (authState) {
        await DataModel.saveUserData('twitter', twitterRef.current.value);
      }
    }
  };

  //Twitter
  const onChangeTwitter = (e) => {
    setTwitterValue(e.target.value);
    localStorage.setItem('twitterURL', twitterRef.current.value);
  };

  //メタマスクログアウト
  const logoutMetaMask = async (e) => {
    if (authState) {
      //Firebaseからサインアウト
      signOut(getAuth()).then(() => {
        setAuthState(false);
        localStorage.removeItem('token');
        localStorage.removeItem('imageURL');
        localStorage.removeItem('displayName');
        localStorage.removeItem('backImageURL');
        localStorage.removeItem('nftID');
        localStorage.removeItem('isAuth');

        setPageState('main');

        if (isElectron) {
          window.myapi.closeWindow();
        } else {
          navigate('/');
        }
      });
    }
  };

  //レンダービュー
  const renderScreen = () => {
    let rightArea;

    if (settingState == 'faq') {
      rightArea = <FAQ />;
    } else if (settingState == 'contact') {
      rightArea = <Feedback />;
    } else if (settingState == 'profile') {
      rightArea = (
        <>
          <div id="settingProfileBox">
            <div id="settingProfileImage">
              <FaceImage myNftState={myNftState} tapFace={onClickEditFace} />
              {/* <img src={'./images/nft/thumb/' + myNftState + '.png'} onClick={onClickEditFace} /> */}
            </div>
            <div>
              <div id="settingProfileStatus">
                <div className="settingProfileItem">
                  <div className="settingProfileTitle">{t('setting.Status')}</div>
                  <div className="settingProfileBody">
                    {authState ? t('setting.Logged in') : t('setting.Not Logged in')}{' '}
                  </div>
                </div>
                <div className="settingProfileItem">
                  <div className="settingProfileTitle">{t('setting.Member')}</div>
                  <div className="settingProfileBody">{t('setting.Basic')}</div>
                </div>
              </div>
              <div id="settingProfileEdit" onClick={onClickEditFace}>
                <button>{t('setting.Edit Avatar')}</button>
              </div>
            </div>
          </div>
          {/* 名前の入力欄 */}
          <div className="settingInputWrap">
            <label htmlFor="username" id="userName">
              {t('setting.Display Name')}
            </label>
            <input
              ref={userNameRef}
              name="username"
              type="text"
              placeholder={t('setting.Type Display Name')}
              onChange={(e) => onChangeName(e)}
              value={displayNameState ?? ''}
              //disabled={!userNameState ? 'disabled' : false}
              onBlur={userNameBlur}
            />

            {/* {!userNameState && (
              <div className="settingEditButton">
                <button onClick={editNameStart}> {t('setting.Edit')}</button>
              </div>
            )} */}
          </div>

          {/* AboutMeの入力欄 */}
          <div className="settingInputWrap" style={{ marginTop: '13px' }}>
            <label htmlFor="username" id="userName">
              {t('setting.About Me')}
            </label>
            <textarea
              ref={aboutMeRef}
              placeholder=""
              value={aboutMeState ?? ''}
              onChange={(e) => onChangeAboutMe(e)}
              // disabled={!aboutMeBlurState ? 'disabled' : false}
              onBlur={aboutMeBlur}></textarea>
          </div>

          <div className="settingSpace"></div>

          {/* Twitterの入力欄 */}
          {/* <div className="settingInputWrap">
            <label htmlFor="twitter" id="twitter">
              Twitter URL
            </label>
            <input
              ref={twitterRef}
              name="twitter"
              type="text"
              placeholder="https://twitter.com/faceless"
              onChange={(e) => onChangeTwitter(e)}
              value={twitterValue}
              disabled={!twitterState ? 'disabled' : false}
            />

            <div className="settingEditButton">
              <button onClick={editTwitterStart}>{!twitterState ? 'Edit' : 'Save'}</button>
            </div>
          </div> */}

          {/* {authState && (
            <div id="settingLogout">
              <button onClick={logoutMetaMask}>Logout</button>
            </div>
          )} */}
        </>
      );
    } else if (settingState == 'camera') {
      rightArea = (
        <div>
          <label htmlFor="cameraOptions">{t('setting.Camera')}</label>
          <select
            name="cameraOptions"
            id="cameraSelect"
            onChange={updateCamera}
            value={cameraSelected}>
            {cameraListRef.current?.map((camera) => (
              <option key={`cam-${camera.deviceId}`} value={camera.deviceId}>
                {camera.label}
              </option>
            ))}
            {/* {cameras?.map((camera) => (
              <option key={`cam-${camera.device.deviceId}`} value={camera.device.deviceId}>
                {camera.device.label}
              </option>
            ))} */}
          </select>
        </div>
      );
    } else if (settingState == 'audio') {
      rightArea = (
        <>
          <div>
            <label htmlFor="micOptions">{t('setting.Microphone')}</label>
            <select
              name="cameraOptions"
              id="cameraSelect"
              onChange={updateMicrophone}
              value={micSelected}>
              {micListRef.current?.map((mic) => (
                <option key={`cam-${mic.deviceId}`} value={mic.deviceId}>
                  {mic.label}
                </option>
              ))}
            </select>
            {/* <select name="micOptions" id="micSelect" onChange={updateMicrophone}>
              {microphones?.map((mic) => (
                <option key={`mic-${mic.device.deviceId}`} value={mic.device.deviceId}>
                  {mic.device.label}
                </option>
              ))}
            </select> */}
          </div>

          <div style={{ marginTop: '30px' }}>
            <label htmlFor="speakersOptions">{t('setting.Speakers')}</label>
            <select
              name="speakersOptions"
              id="speakersSelect"
              onChange={updateSpeakers}
              value={
                localStorage.getItem('speakerOutput') == null
                  ? 'default'
                  : localStorage.getItem('speakerOutput')
              }>
              {speakerListRef.current?.map((speaker) => (
                <option key={`speaker-${speaker.deviceId}`} value={speaker.deviceId}>
                  {speaker.label}
                </option>
              ))}
            </select>
          </div>
        </>
      );
    } else if (settingState == 'language') {
      rightArea = (
        <>
          <div>
            <label htmlFor="cameraOptions">{t('setting.Language')}</label>
            <select
              name="languageOptions"
              id="cameraSelect"
              onChange={updateLanguage}
              value={i18n.language}>
              <option key="language1" value="en">
                {t('setting.English')}
              </option>
              <option key="language2" value="ja">
                {t('setting.Japanese')}
              </option>
            </select>
          </div>
        </>
      );
    }

    return (
      <>
        <div id="backWrap" onClick={tapBack}></div>
        <div id="settingWrap" style={{ borderRadius: isWindows && isElectron ? '0px' : '10px' }}>
          <div id="settingDragArea"></div>
          <div id="settingCloseButton">
            <CloseSVG onClick={tapBack} />
          </div>

          <div id="settingGridWrap">
            <div id="settingGridLeft">
              <div id="settingLeftTitle">{t('setting.Setting')}</div>
              <div
                className={
                  settingState == 'profile' ? 'settingMenu settingMenuSelected' : 'settingMenu'
                }
                onClick={tapProfile}>
                {/* <img src="/images/buttons/settingProfileButton.svg" /> */}
                <ProfileSVG />
                {t('setting.Profile')}
              </div>
              {/* 
              <div
                className={
                  settingState == 'account' ? 'settingMenu settingMenuSelected' : 'settingMenu'
                }
                onClick={tapAccount}>
                <AccountSVG />
                Account
              </div> */}
              <div
                className={
                  settingState == 'camera' ? 'settingMenu settingMenuSelected' : 'settingMenu'
                }
                onClick={tapCamera}>
                {/* <img src="/images/buttons/settingCameraButton.svg" /> */}
                <CameraSVG />
                {t('setting.Camera')}
              </div>

              <div
                className={
                  settingState == 'audio' ? 'settingMenu settingMenuSelected' : 'settingMenu'
                }
                onClick={tapAudio}>
                {/* <img src="/images/buttons/settingAudioButton.svg" /> */}
                <AudioSVG />
                {t('setting.Audio')}
              </div>

              <div
                className={
                  settingState == 'language' ? 'settingMenu settingMenuSelected' : 'settingMenu'
                }
                onClick={tapLanguage}>
                <LanguageSVG />
                {t('setting.Language')}
              </div>

              <div className="settingLine"></div>

              {/* <div
                className={
                  settingState == 'faq' ? 'settingMenu settingMenuSelected' : 'settingMenu'
                }
                onClick={tapFAQ}>
                <FAQSVG />
                {t('setting.FAQ')}
              </div> */}

              <div
                className={
                  settingState == 'contact' ? 'settingMenu settingMenuSelected' : 'settingMenu'
                }
                onClick={tapContact}>
                <ContactSVG />
                {t('setting.Feedback / Contact')}
              </div>

              {localStorage.getItem('isAuth') != null && (
                <div
                  className={
                    settingState == 'logout' ? 'settingMenu settingMenuSelected' : 'settingMenu'
                  }
                  onClick={tapLogout}>
                  {/* <img src="/images/buttons/settingAudioButton.svg" /> */}
                  <LogoutSVG />
                  {t('setting.Logout')}
                </div>
              )}
            </div>

            <div id="settingGridRight">{rightArea}</div>
          </div>
        </div>
      </>
    );
  };

  return renderScreen();
}
